import React from "react";
import { motion } from "framer-motion";
import { Sparkles, CheckCircle2, HeartHandshake } from "lucide-react";
import { Section } from "@/components/Primitives";
import { useLang } from "@/context/LanguageContext";

export const AccompanimentSection = ({ compact = false }) => {
  const { t } = useLang();
  const items = ["item1", "item2", "item3", "item4"];

  return (
    <section data-testid="accompaniment-section" className={compact ? "bg-white" : "bg-[#F8F9FA]"}>
      <Section className={compact ? "py-12" : "py-20"}>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
          className="relative overflow-hidden rounded-2xl bg-navy text-white p-8 sm:p-12"
        >
          <div className="pointer-events-none absolute -top-28 -right-20 w-80 h-80 rounded-full bg-gold/12 blur-[110px]" />
          <div className="pointer-events-none absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-gold/8 blur-[100px]" />

          <div className="relative z-10 grid lg:grid-cols-2 gap-10 lg:gap-14 items-start">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-4 py-1.5 text-xs uppercase tracking-[0.2em] text-gold">
                <Sparkles size={13} /> {t("journey.badge")}
              </span>
              <h2 data-testid="accompaniment-title" className="mt-5 font-heading text-3xl sm:text-4xl text-white leading-tight">
                {t("journey.title")}
              </h2>
              <div className="gold-line mt-5" />
              <div className="mt-6 space-y-4 text-white/85 leading-relaxed text-sm sm:text-base">
                <p>{t("journey.p1")}</p>
                <p>{t("journey.p2")}</p>
              </div>
              <div className="mt-6 flex items-start gap-3 border-l-2 border-gold bg-white/[0.07] backdrop-blur-sm px-5 py-4">
                <HeartHandshake size={18} className="text-gold shrink-0 mt-0.5" />
                <p className="text-sm text-white font-medium">{t("journey.p3")}</p>
              </div>
            </div>

            <ul className="space-y-3.5">
              {items.map((k, i) => (
                <motion.li
                  key={k}
                  initial={{ opacity: 0, x: -16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.08 * i }}
                  data-testid={`accompaniment-${k}`}
                  className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/[0.04] px-5 py-4 hover:border-gold/60 transition-colors"
                >
                  <CheckCircle2 size={19} className="text-gold shrink-0 mt-0.5" />
                  <span className="text-sm sm:text-base text-white/90">{t(`journey.${k}`)}</span>
                </motion.li>
              ))}
            </ul>
          </div>
        </motion.div>
      </Section>
    </section>
  );
};
